// extracted by mini-css-extract-plugin
module.exports = {"button-with-tooltip":"FilesWorkReportApproverButton_button-with-tooltip__1TYpe","container":"FilesWorkReportApproverButton_container__1OmMB"};